module.exports = __webpack_public_path__ + "static/media/पा_1.6f1d6ae6.ogg";